<template lang="">
  <v-dialog v-model="dialog" width="620px">
    <v-card>
      <v-card-title class="primary white--text"
        ><v-toolbar-title class="text-uppercase">THÊM KỲ {{ titleType }}</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text class="mt-6">
        <v-form ref="form" flat v-model="valid" lazy-validation>
          <v-row>
            <v-col cols="6" class="style1">
              <v-autocomplete
                v-model="period"
                clear-icon="mdi-close"
                :items="sortPeriods"
                item-text="title"
                v-bind:label="`Kỳ ${titleType}`"
                placeholder="Tháng --/----"
                clearable
                outlined
                dense
                return-object
                :rules="[rules.required, isPeriod]"
              >
              </v-autocomplete>
            </v-col>
            <v-col cols="12" v-if="groupHeadFee.scope === 'group'" class="style">
              <v-divider v-if="inputToggle"></v-divider>
              <v-radio-group v-if="inputToggle" v-model="type" class="small-radio" row :rules="[rules.required]">
                <v-radio label="Giảm trừ theo mức phí cụ thể" value="fixed"></v-radio>
                <v-radio label="Giảm trừ theo phần trăm khoản phí" value="percentage"></v-radio>
              </v-radio-group>
            </v-col>
            <v-col cols="6" v-if="groupHeadFee.scope === 'group'">
              <v-text-field
                :value="price"
                @input="handlePrice"
                v-bind:label="changeTextInput"
                v-bind:placeholder="changeTextInput"
                clearable
                outlined
                dense
                return-object
                :rules="[rules.required, rules.isNumber, regexTestPercentage]"
              >
              </v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="mt-5">
        <v-btn depressed outlined color="grey darken-1" class="px-6 ml-4 mt-n4 mb-2 white--text" @click="cancel"
          >Hủy</v-btn
        >
        <v-spacer />
        <v-btn
          depressed
          class="px-6 mr-4 mt-n4 mb-2 white--text"
          :loading="loading"
          :disabled="loading"
          color="primary"
          @click="save"
        >
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { inputRules } from '../../../plugins/rule'
import { mapActions, mapState } from 'vuex'
import { sortPeriod } from './helper/period'
import { placeHolderInput } from '@/modules/tuitionFee/head-fee/helper/headerHelper'

export default {
  props: {
    state: Boolean,
    groupHeadFee: Object,
    prices: Array
  },
  data() {
    return {
      dialog: false,
      loading: false,
      period: '',
      price: '',
      type: 'fixed',
      rules: inputRules,
      valid: true
    }
  },
  created() {
    this.fetchPeriods()
  },
  computed: {
    titleType() {
      if (this.$route.name === 'head-fees') return 'đóng'
      return this.$route.meta.title.replace('Chi tiết khoản', '')
    },
    ...mapState('tuitonFeeHeadFee', ['headFee', 'router', 'isSubFee']),
    ...mapState('tuitionFeePeriod', ['periods']),
    changeTextInput() {
      return placeHolderInput(this.router, this.isSubFee, this.type)
    },
    sortPeriods() {
      let periods = sortPeriod(this.periods)
      return periods
    },
    inputToggle() {
      if (this.groupHeadFee.scope === 'group' && this.router === 'priority' && this.isSubFee === false) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapActions('tuitonFeeHeadFee', ['createPriceGroupHeadFee', 'getGroupHeadFeeByHeadFee']),
    ...mapActions('tuitionFeePeriod', ['fetchPeriods']),
    cancel() {
      this.$refs.form.reset()
      this.dialog = false
    },
    handlePrice(value) {
      if (value) {
        let number = value.split(/\s*,\s*/).join('')
        this.price = (+number).toLocaleString('en-US')
      }
    },
    validate() {
      return this.$refs.form.validate()
    },
    regexTestPercentage(number) {
      return !(this.type === 'percentage' && +number > 100) || !number || 'Mức giảm trừ tối đa 100%'
    },
    isPeriod(period) {
      return (
        !period ||
        !this.prices.find(price => price.period.title === period.title) ||
        (this.router === 'priority'
          ? this.isSubFee === true
            ? 'Kỳ hoàn trả này đã tồn tại '
            : 'Kỳ giảm trừ này đã tồn tại'
          : this.isSubFee === true
            ? 'Kỳ truy thu này đã tồn tại '
            : 'Kỳ đóng này đã tồn tại')
      )
    },
    async save() {
      this.loading = true
      if (this.validate()) {
        try {
          let payload = {
            groupHeadFeeId: this.groupHeadFee.id,
            price: {
              price: this.price.split(/\s*,\s*/).join(''),
              type: this.type,
              period: this.period.id
            }
          }
          await this.createPriceGroupHeadFee(payload)
          await this.getGroupHeadFeeByHeadFee(this.$route.params.id)
          this.loading = false
          this.$alert.addSuccess(`kỳ ${this.titleType}`)
          this.dialog = false
          this.$refs.form.reset()
          this.type = 'fixed'
        } catch (error) {
          this.$alert.updateError({
            title: 'Lỗi thao tác',
            description: `Không thể thêm mới kỳ ${this.titleType}. Vui lòng thử lại`
          })
        }
      }
      this.loading = false
    }
  },
  watch: {
    state() {
      this.dialog = true
    },
    price() {
      new Intl.NumberFormat('vi-VN').format(this.price)
    }
  }
}
</script>
<style lang="scss" scoped>
.data-picker,
.text-field {
  width: 280px;
}
.style {
  margin-bottom: -15px !important;
}
.style1 {
  margin-bottom: -19px !important;
}
</style>
